import axios, { AxiosError, AxiosInstance } from 'axios';
import { NetworkError } from '../errors/network-error';
import { config } from '@utils/config';

// is used without JWT for requests from pages without authorisation (affordability-calculator)
export const API_UNPROTECTED: AxiosInstance = axios.create({
  baseURL: config.env.VITE_API_URL,
});

API_UNPROTECTED.interceptors.response.use(
  response => response,
  (error: AxiosError) => {
    if (error.code == 'ERR_NETWORK') {
      throw new NetworkError("Couldn't connect to the server");
    }

    return Promise.reject(error);
  },
);
